import { DefaultRequestStatus, RequestStatus } from "ecom-teams-apps-core";
import { action, makeObservable, observable, runInAction } from "mobx";
import { TaskStatus } from "../../shared/models/TaskStatus";
import defaultTaskStatusesService, { TaskStatusesService } from "../service/TaskStatusesService";
import { TaskStatusesFromResponse } from "../service/TaskStatusesFromResponse";

export type TaskStatuses = {
    [itemKey: string]: TaskStatus[];
};

export interface TaskStatusesStore {
    taskStatuses: TaskStatuses;
    loadTasksStatusesRequestStatus: RequestStatus;

    loadTaskStatuses: () => void;
}

export class DefaultTaskStatusesStore implements TaskStatusesStore {
    constructor(private taskStatusesService: TaskStatusesService, private loadTasksStatusesReqStatus: RequestStatus) {
        makeObservable(this, {
            loadTaskStatuses: action,
            taskStatuses: observable,
        });
    }

    public taskStatuses: TaskStatuses = {};

    public get loadTasksStatusesRequestStatus() {
        return this.loadTasksStatusesReqStatus;
    }

    public async loadTaskStatuses() {
        let fetchedTasks = await this.loadTasksStatusesReqStatus.handleAnyRequest(() =>
            this.taskStatusesService.getTaskStatuses()
        );

        runInAction(() => {
            if (fetchedTasks) {
                let statuses: TaskStatuses = {};

                for (let i = 0; i < fetchedTasks.length; i++) {
                    statuses[fetchedTasks[i].code] = new TaskStatusesFromResponse(fetchedTasks[i]).taskStatuses();
                }

                this.taskStatuses = statuses;
            }
        });
    }
}

export default new DefaultTaskStatusesStore(defaultTaskStatusesService, new DefaultRequestStatus());
